import { trackBillingPortalOpened } from "@/lib/analytics/billing-analytics"
import { isApiSuccessBody } from "@/lib/api/api-envelope"
import type { ApiBillingPortalPayload } from "@/lib/api/billing-contract"

export async function requestBillingPortalUrl(opts?: {
  surface?: string
}): Promise<{ ok: true; url: string } | { ok: false; message: string }> {
  const res = await fetch("/api/billing/portal", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: "{}",
  })
  const body: unknown = await res.json()
  if (!res.ok || !isApiSuccessBody<ApiBillingPortalPayload>(body)) {
    return { ok: false, message: "Billing portal is not available right now." }
  }
  const d = body.data
  if (d.status === "ready" && d.url) {
    trackBillingPortalOpened(opts?.surface?.trim() || "unknown")
    return { ok: true, url: d.url }
  }
  if (d.status === "not_configured") {
    return {
      ok: false,
      message: d.message ?? "Billing portal is not configured yet.",
    }
  }
  return { ok: false, message: "Billing portal is not configured yet." }
}
